import React, { ButtonHTMLAttributes } from 'react';
import { FaSortDown } from 'react-icons/fa';
import { ItemProps, ModalSelect } from './modal';

import { Container, ButtonProps } from './styles';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  modalTitle: string;
  modalVisible: boolean;
  items?: ItemProps<any>[];
  onClick: () => void;
  onSelectItem: (item: ItemProps<any>) => void;
}

const ButtonSelect: React.FC<Props & ButtonProps> = (props) => {
  return (
    <>
      <Container
        onClick={props.onClick}
        backgroundColor={props.backgroundColor}
        textColor={props.textColor}
        width={props.width}
      >
        {props.children} <FaSortDown color={props.textColor} />
      </Container>

      {props.modalVisible && props.items && (
        <ModalSelect
          title={props.modalTitle}
          onCloseModal={props.onClick}
          onSelectItem={props.onSelectItem}
          items={props.items}
        />
      )}
    </>
  );
};

export { ButtonSelect };
